import { Eye } from "feather-icons-react/build/IconComponents";

export const endorsementColumns = [
  {
    accessorKey: "Company",
    header: "Company",
    enableSorting: true,
  },
  {
    accessorKey: "agency",
    header: "Agency",
    enableSorting: true,
  },
  {
    accessorKey: "endorsement_number",
    header: "Endorsement Number",
    enableSorting: true,
  },
  {
    accessorKey: "Submission_Number",
    header: "Submission Number",
    enableSorting: true,
  },
  {
    accessorKey: "effective_date",
    header: "Effective Date",
    enableSorting: true,
  },
  {
    accessorKey: "createdAt",
    header: "Date Submitted",
    enableSorting: true,
  },
  {
    accessorKey: "quote_request",
    header: "Quote Request",
    enableSorting: true,
    cell: ({ row }) => {
      const quoteRequest = row.original.quote_request;

      let colorClasses = quoteRequest === true
        ? "bg-purple-100 text-purple-800"
        : "bg-gray-100 text-gray-800";

      return (
        <span
          className={`
            inline-flex items-center px-2.5 py-0.5 rounded-md font-medium ${colorClasses}
          `}
        >
          {quoteRequest === true ? 'Yes' : 'No'}
        </span>
      );
    },
  },
  {
    accessorKey: "status",
    header: "Status",
    enableSorting: true,
    cell: ({ row }) => {
      const status = row.original.status;

      let colorClasses = "bg-gray-100 text-gray-800";

      if (status === "active") {
        colorClasses = "bg-blue-100 text-blue-800";
      } else if (status === "bound") {
        colorClasses = "bg-green-100 text-green-800";
      } else if (status === "declined") {
        colorClasses = "bg-red-100 text-red-800";
      } else if (status === "not_taken_up") {
        colorClasses = "bg-gray-100 text-gray-800";
      } else if (status === "permanently_delete_ticket") {
        colorClasses = "bg-black text-white";
      }

      return (
        <span
          className={`inline-flex items-center px-2.5 py-0.5 rounded-md font-medium ${colorClasses}`}
        >
          {status.charAt(0).toUpperCase() + status.slice(1)}
        </span>
      );
    },
  },
  {
    id: "actions",
    header: "Actions",
    cell: ({ row }) => {
      return (
        <button
          onClick={() => row.original.handleView(row.original)}
          className="text-gray-400 hover:text-gray-600"
        >
          <Eye size={20} />
        </button>
      );
    },
  },
];